function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { register } from 'ovee.js';
import YTPlayer from 'yt-player';
import BaseVideoPlayer from './BaseVideoPlayer';
var YT_REGEX = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/gi;

var _class = (_dec = register('player-youtube'), _dec(_class2 = /*#__PURE__*/function (_BaseVideoPlayer) {
  _inherits(_class2, _BaseVideoPlayer);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      var _this$link$matchAll$n,
          _this = this;

      this.link = this.$element.dataset.playerYoutube;
      this.videoId = ((_this$link$matchAll$n = this.link.matchAll(YT_REGEX).next().value) === null || _this$link$matchAll$n === void 0 ? void 0 : _this$link$matchAll$n[1]) || new URL(this.link).search.slice(3);

      if (!this.videoId) {
        this.$element.parentElement.remove(this.$element);
        return;
      }

      this.player = new YTPlayer(this.$element.querySelector('.external-video__iframe'), {
        related: false,
        modestBranding: true,
        host: "".concat(window.location.protocol, "//www.youtube.com")
      });
      this.player.load(this.videoId);
      this.player.on('playing', function () {
        _this.$element.classList.add('is-active');

        _this.setLoading(false);
      });
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            _this.pause();
          }
        });
      }, {
        threshold: 0
      });
      this.observer.observe(this.$element);
      this.bind();
    }
  }, {
    key: "clickHandler",
    value: function clickHandler() {
      var state = this.player.getState();

      if (state !== 'playing') {
        this.play();
      }
    }
  }, {
    key: "bind",
    value: function bind() {
      this.$on('click', this.$element, this.clickHandler);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.player) {
        this.player.destroy();
      }

      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }]);

  return _class2;
}(BaseVideoPlayer)) || _class2);

export { _class as default };